import { AddFilledIcon, ChevronDownIcon, ChevronUpIcon } from '@calizahq/react-components-v2'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { BottomSheet, Tag } from '@/components'
import { useToggle } from '@/hooks'
import { TicketDetail } from '@/types/Ticket'

import { CreateTicketForm } from '../../../../forms/CreateTicket/CreateTicketForm'
import { getStatusTagClassName } from '../../Tickets/Tickets.data'

type Props = {
  childTickets: TicketDetail['childTickets']
  contactId?: number
  homeId?: number
  parentTicketId: number
  refetchDetails: () => void
  reservationId?: number
}

export const ChildTicketsSection = ({
  childTickets,
  contactId,
  homeId,
  parentTicketId,
  refetchDetails,
  reservationId,
}: Props) => {
  const [expanded, setExpanded] = useState(true)
  const { isShown: createShown, toggle: createToggle } = useToggle()

  const toggleExpand = () => setExpanded((prev) => !prev)

  const handleCreateClose = () => {
    createToggle()
    refetchDetails()
  }

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between py-2">
        <div className="flex cursor-pointer items-center gap-2" onClick={toggleExpand} role="presentation">
          <p className="font-bold">Child Tickets ({childTickets.length})</p>
          {expanded ? <ChevronUpIcon className="h-4 w-4" /> : <ChevronDownIcon className="h-4 w-4" />}
        </div>
        <button
          className="text-action-primary hover:opacity-70"
          onClick={createToggle}
          title="Create child ticket"
          type="button"
        >
          <AddFilledIcon className="h-5 w-5" />
        </button>
      </div>

      {expanded && (
        <div className="flex flex-col gap-2">
          {childTickets.map((child) => (
            <div
              className="flex items-center justify-between rounded-lg border px-3 py-2 border-secondary"
              key={child.id}
            >
              <div className="flex min-w-0 flex-col gap-0.5">
                <div className="flex items-baseline gap-1.5 truncate">
                  <Link className="shrink-0 text-p-sm text-tertiary underline" to={`/tickets/${child.id}`}>
                    #{child.id}
                  </Link>
                  <span className="shrink-0 text-p-sm text-tertiary">·</span>
                  <Link className="truncate text-p-sm font-medium" to={`/tickets/${child.id}`}>
                    {child.subject}
                  </Link>
                </div>
                {child.assignee?.fullName && <p className="text-p-xs text-tertiary">{child.assignee.fullName}</p>}
              </div>
              <div className="ml-3 flex shrink-0 items-center">
                <Tag className={getStatusTagClassName(child.internalTicketStatus)} variant="none">
                  {child.internalTicketStatus}
                </Tag>
              </div>
            </div>
          ))}
        </div>
      )}

      <BottomSheet isVisible={createShown} onClose={handleCreateClose}>
        <CreateTicketForm
          contactId={contactId}
          homeId={homeId}
          memberId={contactId}
          parentTicketId={parentTicketId}
          refetchOnSuccess={refetchDetails}
          reservationId={reservationId}
          toggle={handleCreateClose}
        />
      </BottomSheet>
    </div>
  )
}
